import React from 'react';

function Guaranty() {
  return (
    <>
      <h2 className="font-bold text-center p-3 pt-0" id="guarantee"> Гарантії</h2>
      <div className="p-3">
        <p>
      Ми дуже стараємося давати нашим клієнтам не просто одяг, а і впевненість в тому що ви отримаєте продукт який буде не
      тільки зручним та стильним, а ще й надійним і довговічним. Тому надаємо гарантію на усю продукцію <span className="font-bold">DMK</span>  – 6 місяців. Якщо
      у вас виникла якась проблема - скажіть нам про це і ми обов’язково виправимо ситуацію, а ваша інформація допоможе нам
      зробити продукт ще кращим!
      <br/><br/>
      Для цього напишіть нам в інстаграм ( <a className="color-blackk" href="https://www.instagram.com/dmk.style_man_/?hl=uk">@dmk.style_man_</a> ) або зателефонуйте - <a className="color-blackk" href="tel:0508886567">050 888 65 67</a> .
      <p className="font-size pb-1">Гарантійні зобов’язання:</p> 
      <ol>
        <li>
        Приймаємо претензії щодо якості взуття за наявності товарного чеку на це взуття або за номером телефону, який
      вказували при замовленні (в такому випадку чек не потрібен) , протягом 180 календарних днів з дати продажу із
      зазначенням конкретних дефектів. 
        </li>
        <li>
        Варіанти вирішення гарантійного дефекту: 
        <ul>
          <li>ремонт</li>
          <li>обмін на нову пару цієї моделі або ж іншої, якщо даної моделі не буде в наявності (звичайно, нову модель виберете сам,
      якщо вона буде дешевша, то ми повернемо різницю і навпаки, якщо дорожча - потрібно буде доплатити різницю. Після надання
      вами усієї потрібної інформації щодо дефекту, наш спеціаліст визначить який із трьох варіантів вирішення можемо вам
      запропонувати.</li>
        </ul>
        </li>
        <li>Дефекти взуття, які можуть бути усунені нами без зниження(!) його споживчих властивостей (відклейка декоративного
        ранту, розрив нитки на прошивній підошві, відрив фурнітури, поломка замків-блискавок, відставання набійки, відклеювання
        підошви та ін.) не є підставою для повернення коштів та обміну. Такі дефекти ми усуваємо шляхом ремонту.</li>
      <li>Претензії щодо якості не приймаються:
        <ul>
          <li> на взуття з пошкодженнями, що виникли внаслідок його фізичного зношування
          </li>
          <li>якщо взуття пралось/замочувалось у воді або оброблялось хімічними засобами та шампунями не призначеними для взуття.
          </li>
          <li>якщо взуття уцінене у зв’язку з частковою втратою якості чи очевидними дефектами, на які було вказано продавцем при
      покупці - якщо наявні механічні або хімічні пошкодження
          </li>
        </ul>
      </li>
      </ol>
      <p className="font-bold">У будь-якому випадку, ви завжди можете звернутись до нас і ми підкажемо, як вирішити вашу проблему.</p></p>
    </div>
</>
  );  
}

export default Guaranty;